const eligibleCountryCodes = [
  'AF',
  'AG',
  'AJ',
  'AL',
  'AM',
  'AO',
  'AQ',
  'AR',
  'AS',
  'AU',
  'BA',
  'BC',
  'BE',
  'BG',
  'BK',
  'BL',
  'BM',
  'BN',
  'BO',
  'BR',
  'BT',
  'BU',
  'BX',
  'BY',
  'CB',
  'CD',
  'CE',
  'CF',
  'CG',
  'CH',
  'CI',
  'CK',
  'CM',
  'CN',
  'CO',
  'CT',
  'CV',
  'CW',
  'CY',
  'CZ',
  'DA',
  'DJ',
  'EC',
  'EG',
  'EI',
  'EK',
  'EN',
  'ER',
  'ET',
  'FG',
  'FI',
  'FJ',
  'FK',
  'FM',
  'FO',
  'FP',
  'FR',
  'GA',
  'GB',
  'GG',
  'GH',
  'GI',
  'GK',
  'GM',
  'GQ',
  'GR',
  'GV',
  'GY',
  'HR',
  'HU',
  'IC',
  'ID',
  'IM',
  'IN',
  'IR',
  'IS',
  'IT',
  'IV',
  'IZ',
  'JA',
  'JE',
  'JO',
  'KE',
  'KG',
  'KR',
  'KS',
  'KT',
  'KU',
  'KZ',
  'LA',
  'LE',
  'LG',
  'LH',
  'LI',
  'LO',
  'LT',
  'LU',
  'LY',
  'MA',
  'MC',
  'MD',
  'MF',
  'MG',
  'MI',
  'MK',
  'ML',
  'MO',
  'MP',
  'MR',
  'MT',
  'MU',
  'MV',
  'MY',
  'MZ',
  'NC',
  'NE',
  'NF',
  'NG',
  'NH',
  'NI',
  'NL',
  'NO',
  'NP',
  'NS',
  'NZ',
  'PA',
  'PE',
  'PK',
  'PL',
  'PO',
  'PP',
  'PS',
  'PU',
  'QA',
  'RE',
  'RM',
  'RO',
  'RP',
  'RS',
  'RW',
  'SA',
  'SE',
  'SF',
  'SG',
  'SH',
  'SI',
  'SL',
  'SN',
  'SO',
  'SP',
  'SR',
  'SU',
  'SV',
  'SW',
  'SY',
  'SZ',
  'TC',
  'TH',
  'TI',
  'TN',
  'TO',
  'TP',
  'TS',
  'TU',
  'TW',
  'TX',
  'TZ',
  'UG',
  'UK',
  'UP',
  'UV',
  'UY',
  'UZ',
  'VE',
  'VM',
  'WA',
  'WE',
  'WF',
  'WI',
  'WS',
  'WZ',
  'YM',
  'ZA',
  'ZI',
  'HK',
  'NM',
  'MN',
  'PT',
  'KP',
  'ZO',
  'AD',
  'AT',
  'BS',
  'CR',
  'EU',
  'GZ',
  'IO',
  'LS',
  'NR',
  'PN',
  'SM',
  'TL',
  'TT',
  'TV',
  'VA',
  'WQ',
  'KV',
  'MJ',
  'RI',
  'UM',
  'SS',
  'UU',
  'MX',
  'JM',
  'DR',
  'ES',
  'BH',
  'AA',
  'HO',
  'PM',
  'NU',
  'GJ',
  'BB',
]

const US_MX_CA = ['US', 'MX', 'CA']

const paidSEM = [
  'PLGOOGLECPC',
  'PLGOOGLECPCB',
  'PLGOOGLECPCB',
  'PLGOOGLECPCBSL',
  'PLMSN',
  'PLMSNSL',
  'PLMSNB',
  'PLMSNBSL',
]

const phoneBannerVariantNumber = {
  mobile: '1 (855) 940-5834',
  desktop: '1 (855) 940-5824',
}
const paidSEMNumber = {
  mobile: '1 (833) 322-0956',
  desktop: '1 (833) 322-0942',
}
const dtdDirectNumber = {
  desktop: '1 (855) 940-4266',
  mobile: '1 (855) 940-4224',
}
const defaultPhoneNumber = {
  mobile: '1 (855) 940-4288',
  desktop: '1 (855) 940-4246',
}

export {
  US_MX_CA,
  eligibleCountryCodes,
  paidSEM,
  phoneBannerVariantNumber,
  paidSEMNumber,
  dtdDirectNumber,
  defaultPhoneNumber,
}
